import React from "react";
import useTheme from "@mui/material/styles/useTheme";
import PropTypes from "prop-types";
import { Button, Section } from "@arp/react-ndbx";
import ContactUsModal from "./ContactUsModal";

function HeaderBase({ logoImage, buttonTitle, contactUsImg }) {
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <Section
      data-identifier="main-header"
      mt={0}
      mb={0}
      sx={{
        display: "flex",
        justifyContent: "space-between",
        px: {
          xs: 3,
          sm: 4,
        },
        height: 60,
        alignItems: "center",
        borderBottom: `1px solid ${theme.palette.greyscale.Grey100}`,
      }}
    >
      <Section
        data-identifier="header-image"
        sx={{ maxWidth: 120, display: "flex", alignItems: "center" }}
      >
        <img width="100%" src={logoImage}></img>
      </Section>
      <Section
        data-identifier="header-button"
        sx={{ display: "flex", justifyContent: "end" }}
      >
        <Button
          id="contact-us"
          ariaLabel="Contact-us"
          color="secondary"
          variant="contained"
          label="Primary"
          size="small"
          sx={{ textTransform: "none" }}
          onClick={handleOpen}
        >
          {buttonTitle}
        </Button>
        <ContactUsModal
          open={open}
          handleClose={handleClose}
          contactUsImg={contactUsImg}
        />
      </Section>
    </Section>
  );
}

HeaderBase.propTypes = {
  logoImage: PropTypes.string.isRequired,
  buttonTitle: PropTypes.string.isRequired,
  contactUsImg: PropTypes.string.isRequired,
};

HeaderBase.defaultProps = {
  logoImage:
    "https://www.allianz.com/content/dam/onemarketing/system/allianz-logo.svg",
  buttonTitle: "Contact us",
  contactUsImg:
    "https://www.allianzretireplus.com.au/content/dam/onemarketing/azau/allianz-life-dam/images/woman-with-laptop-headset.svg",
};

export default HeaderBase;
